import styled, { css } from 'styled-components';
import mediaQuery from 'styles/mediaQuery';

export const Container = styled.main``;

export const HeroSection = styled.section`
  padding: ${({ theme }) => theme.spaces.padding.xxl} 0;
  display: flex;
  gap: ${({ theme }) => theme.spaces.gap.xxl};

  & > div {
    display: flex;
    flex-direction: column;
    gap: ${({ theme }) => theme.spaces.gap.md};
  }

  h1 {
    color: ${({ theme }) => theme.system.blue.surface.primary};
    margin-bottom: 0;
  }

  p {
    font-size: ${({ theme }) => theme.typography.sizes.lg};
    margin-bottom: 0;
  }

  button {
    width: fit-content;
  }

  ${mediaQuery.sm} {
    flex-direction: column;
  }
`;

const commonSectionStyles = css`
  padding: ${({ theme }) => theme.spaces.padding.xxl} 0;
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.spaces.gap.md};
`;

export const BenefitsSectionBackground = styled.div`
  background: ${({ theme }) => theme.colors.palette.success[50]};
`;

export const BenefitsSection = styled.section`
  ${commonSectionStyles}
`;

export const BenefitsCards = styled.div`
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: ${({ theme }) => theme.spaces.gap.lg};

  ${mediaQuery.sm} {
    grid-template-columns: repeat(2, 1fr);
  }

  ${mediaQuery.xs} {
    grid-template-columns: repeat(1, 1fr);
  }
`;

export const BenefitCard = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.spaces.gap.md};
  border-radius: ${({ theme }) => theme.radius.xl};
  background-color: ${({ theme }) => theme.system.neutral.surface.primary};
  padding: ${({ theme }) => theme.spaces.padding.lg};

  box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.08);
`;

export const ProtectionSection = styled.section`
  ${commonSectionStyles}
`;

export const ProtectionItems = styled.div`
  display: grid;
  grid-template-columns: repeat(5, 1fr);
  gap: ${({ theme }) => theme.spaces.gap.lg};

  ${mediaQuery.sm} {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
`;

export const ProtectionItem = styled.div`
  display: flex;
  padding: ${({ theme }) => theme.spaces.padding.xl};
  flex-direction: column;
  align-items: flex-start;
  gap: ${({ theme }) => theme.spaces.gap.md};

  border-radius: ${({ theme }) => theme.radius.xl};
  background: ${({ theme }) => `${theme.raw.colors.palette.blue[50]}B3`};

  color: ${({ theme }) => theme.system.blue.surface.primary};

  ${mediaQuery.sm} {
    &:last-child {
      grid-column: span 2;
    }
  }
`;

export const CallToActionSection = styled.section`
  ${commonSectionStyles}

  & > div {
    display: flex;
    flex-direction: column;
    gap: ${({ theme }) => theme.spaces.gap.md};

    background: ${({ theme }) => theme.colors.palette.success[50]};
    border-radius: ${({ theme }) => theme.radius.xxl};
    padding: ${({ theme }) => theme.spaces.padding.xl};

    & > div {
      display: flex;
      justify-content: space-between;
      gap: ${({ theme }) => theme.spaces.gap.xl};

      ${mediaQuery.sm} {
        flex-direction: column;
      }
    }
  }
`;

export const ChecklistPoints = styled.div`
  margin: auto 0;

  ul {
    list-style: none;
    padding: 0;
    display: flex;
    flex-direction: column;

    gap: ${({ theme }) => theme.spaces.gap.lg};

    li {
      & > svg {
        width: 16px;
        height: 16px;
      }

      display: flex;
      gap: ${({ theme }) => theme.spaces.gap.sm};
      align-items: center;

      color: ${({ theme }) => theme.system.blue.surface.primary};
      font-size: ${({ theme }) => theme.typography.sizes.lg};
    }
  }
`;

export const SectionTitle = styled.h2<{ color: 'blue' | 'green' }>`
  color: ${({ color, theme }) =>
    color === 'blue'
      ? theme.system.blue.surface.primary
      : theme.system.green.text.light};
  margin: 0;
  font-weight: ${({ theme }) => theme.typography.weight.semibold};
  font-size: ${({ theme }) => theme.typography.sizes.xxl};
`;

export const SectionSubtitle = styled.p`
  font-size: ${({ theme }) => theme.typography.sizes.lg};
  margin: 0 0 ${({ theme }) => theme.spaces.gap.sm};
`;

export const GetProtectionButtonWrapper = styled.div`
  width: 250px;
  height: 50px;
  margin: ${({ theme }) => theme.spaces.padding.lg} auto 0;
`;
